import { useMutation } from "@tanstack/react-query";

import api from "@/api";

const VOCALIZER_URL = process.env["NEXT_PUBLIC_VOCALIZER_URL"] || "/vocalizer";
const REQUEST_TIMEOUT = 40000;

export interface VocalizationResponse {
  download_url: string;
  engine: string;
  identifier: string;
  speech_marks: any;
  voice: string;
}

interface GetTranslatedAudioFileParams {
  text: string;
  languageCode: string;
}

export default function useGetTranslatedAudioFile() {
  const { data, error, isPending, mutate } = useMutation<
    VocalizationResponse,
    Error,
    GetTranslatedAudioFileParams
  >({
    mutationFn: ({ text, languageCode }) => {
      if (!text || !languageCode) {
        throw new Error("required text or languageCode parameter is missing");
      }

      return api({ basePath: VOCALIZER_URL, timeout: REQUEST_TIMEOUT }).post(
        "/text-to-speech",
        { text, language_code: languageCode },
        {},
      );
    },
  });

  return {
    currentAudioData: data,
    error,
    isLoading: isPending,
    fetchTranslatedAudioFile: mutate,
  };
}
